// ===================================================================
// LOADING SPINNER COMPONENT
// ===================================================================
// src/components/common/LoadingSpinner.js
import React from 'react';

/**
 * Reusable loading spinner component
 * Available in multiple sizes for different use cases
 */
const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  return (
    <div className={`animate-spin rounded-full border-2 border-gray-300 border-t-blue-600 ${sizeClasses[size]} ${className}`} />
  );
};

export default LoadingSpinner;